import api from 'configs/api';
import { IRequestResponse } from 'interfaces/RequestResponse';
import {
  IGridDataResponse,
  IGridPredictionChemicalPhysicalData,
  IExportGridData,
} from 'interfaces/Grid';

const endpointUrl = 'prediction/grid/chemical-physical';

export const postGridChemicalPhysical = async (queryString, params) => {
  const url = `${endpointUrl}?${queryString}`;
  const { data } = await api.post<
    IRequestResponse<IGridDataResponse<IGridPredictionChemicalPhysicalData[]>>
  >(url, params);
  return data;
};

export const postExportChemicalPhysicalGrid = async (queryString, params) => {
  const url = `${endpointUrl}/excel?${queryString}`;
  const { data } = await api.post<IExportGridData>(url, params);
  return data;
};

export const putGridChemicalPhysical = async params => {
  const url = `prediction/chemical-physical`;
  const { data } = await api.put<IRequestResponse<null>>(url, params);
  return data;
};
